var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { pxToRem } from "../../utils";
var StyledMemorableDateSpanCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var $chars = _ref.$chars;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n  "])), $chars === 2 && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: ", "rem;\n    "])), pxToRem(64)), $chars === 4 && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: ", "rem;\n    "])), pxToRem(80)));
});
export var StyledMemorableDateSpan = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.cssPrefix;
}, StyledMemorableDateSpanCss);
export var StyledMemorableDateInputContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", " {\n    display: inline-flex;\n    flex-direction: column;\n\n    &:not(:last-child) {\n      margin-right: ", ";\n    }\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing_03;
});
export default styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.cssPrefix;
});